export const wrapWithProps = (Component, props) => {
    return {
        render(h) {
            return h(Component, { props });
        },
    };
};
